module.exports = __webpack_public_path__ + "static/hero-min-aade9d7c4a3960dfccd71fc6dc3b3516.jpg";